import {ReactElement, useState} from "react";
import {ImageGroup} from "./imageCollections";
import {SecondaryButton} from "components/UIComponents/SecondaryButton";
import {IconLabel} from "components/UIComponents/IconLabel";
import {ReactComponent as ImageIcon} from "components/Icons/image.svg";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {FormattedMessage} from "react-intl";
import {ImagePickerPopup} from "./ImagePickerPopup";
import {ImageUploaderProps} from "components/UIComponents/imageupload/ImageUploader";
import {isEmpty} from "ramda";

export type ImageFetchFunction = () => Promise<ImageGroup[]>;
export type ImagePickerImagesArg = ImageGroup[] | ImageFetchFunction;
export function toPromise(i: ImagePickerImagesArg): Promise<ImageGroup[]> {
    if (isImageFetchFunction(i)) {
        return i();
    } else {
        return Promise.resolve(i);
    }
}
function isImageFetchFunction(i: ImagePickerImagesArg): i is ImageFetchFunction {
    return typeof i === 'function';
}

export interface ImagePickerProps {
    images: ImagePickerImagesArg
    currentImage: string | null
    onPick: (url: string | null) => void
    allowClear: boolean
    upload: Omit<ImageUploaderProps, 'onCancel' | 'onSuccess'> | null
}

export function ImagePicker(props: ImagePickerProps): ReactElement {
    const [popupActive, setPopupActive] = useState(false);

    return (
        <>
            {popupActive && (
                <div className="fixed inset-0 z-modal">
                    <ImagePickerPopup
                        images={props.images}
                        onPick={(url) => {
                            props.onPick(url);
                            setPopupActive(false);
                        }}
                        onClose={() => setPopupActive(false)}
                        upload={props.upload}
                    />
                </div>
            )}
            <div className="flex flex-col gap-4">
                <div className="rounded border border-gray-2 overflow-hidden">
                    {(props.currentImage != null && !isEmpty(props.currentImage)) ? (
                        <img alt="Bild"
                             src={props.currentImage}
                             className="object-contain w-full h-auto"
                        />
                    ) : (
                        <div className="py-4 px-4">
                            <IconLabel icon={<ImageIcon />}>
                                <FormattedMessage id="editor.image.notSet" />
                            </IconLabel>
                        </div>
                    )}
                </div>

                <div className="flex gap-5">
                    <SecondaryButton onClick={() => setPopupActive(true)}>
                        <IconLabel icon={<ImageIcon className="h-4 w-4" />}>
                            <FormattedMessage id="editor.image.pick"/>
                        </IconLabel>
                    </SecondaryButton>
                    {(props.allowClear && props.currentImage != null) && (
                        <SecondaryButton onClick={() => props.onPick(null)}>
                            <IconLabel icon={<CloseIcon className="w-4 h-4"/>}>
                                <FormattedMessage id="editor.image.clear"/>
                            </IconLabel>
                        </SecondaryButton>
                    )}
                </div>
            </div>
        </>
    );
}

